import React, { useEffect, useState } from "react"
import Button from "../../../../shared/components/atoms/button/button"
import { graphql, useStaticQuery } from "gatsby"
import validCellphonePY from "../../../../shared/utils/validCellPhonePY"
import OtpModal from "../../../../shared/components/modals/otp-modal/otp-modal"
import AuthService from "../../../../shared/services/auth-service"
import DataPolicy from "../../../../shared/components/atoms/data-policy/data-policy"
import useDataPolicy from "../../../../shared/hooks/useDataPolicy"
import { siteUrl } from "../../../../shared/utils/siteUrl"
import UseChecksPolicy from "../../../../shared/hooks/useChecksPolicy"
import DataPolicyService from "../../../../shared/services/datapolicy-service"

const StepUpdateData = props => {
  let { ACTIVITY_ID_MUESTREO, setActualStep, setModalActive } = props

  const { checksPolicy } = useDataPolicy()
  const { checks, changeCheck, isAllChecksTrue, getPayloadCheck } = UseChecksPolicy()

  const homeLink = siteUrl + "/"

  const resultQuery = useStaticQuery(
    graphql`
        query USER_DATA_QUERY {
            allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
                nodes {
                    node_locale
                    codigoIcu
                    titulo
                    tieneMisPuntos
                    departamentos {
                        codigo
                        nombre
                    }
                    ciudades {
                        codigo
                        codigoDepartamento
                        nombre
                    }
                }
            }
        }
    `,
  )


  var ciudades = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE,
  )[0].ciudades
  var departamentos = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE,
  )[0].departamentos

  var userInfo = JSON.parse(localStorage.getItem("USER_INFO"))

  const getNoPrefix = num => {
    return num.slice(
      process.env.COUNTRY_PHONE_PREFIX.length,
      userInfo.cellPhone.length,
    )
  }

  //Input values
  const [departamentoSelected, setDepartamentoSelected] = useState(
    userInfo.location ? userInfo.location.countryState.toString() : "",
  )
  const [ciudadSelected, setCiudadSelected] = useState(
    userInfo.location ? userInfo.location.city.toString() : "",
  )

  const [nameValue, setNameValue] = useState(userInfo.name)
  const [lastnameValue, setLastnameValue] = useState(userInfo.lastName)
  const [errorMessage, setErrorMessage] = useState("")
  const [phoneValue, setPhoneValue] = useState(
    userInfo.cellPhone !== null
      ? validCellphonePY(getNoPrefix(userInfo.cellPhone))
      : null,
  )
  const [addressValue, setAddressValue] = useState(
    userInfo.location ? userInfo.location.address : "",
  )

  const [addressDetailValue, setaddressDetailValue] = useState(
    userInfo.location ? userInfo.location.addressDetail : "",
  )

  const [zipCodeValue, setZipCodeValue] = useState("")

  const handleChangeChecks = (e, index) => {
    changeCheck(index, e.target.checked)
  }

  useEffect(() => {
    if (process.env.LOCALE === "es-PR") {
      const indexOF = addressDetailValue.indexOf("ZIP")
      if (indexOF !== -1) {
        //Extraer detalle direccion
        let detailAdrres = addressDetailValue.slice(0, indexOF - 1)
        let zip = addressDetailValue.slice(indexOF + 5, indexOF + 10)
        setaddressDetailValue(detailAdrres)
        setZipCodeValue(zip)
      } else {
        setZipCodeValue("")
      }
    } else {
      setZipCodeValue("00000")
    }
  }, [])

  /* ----- Error flags ----- */
  const [nameError, setNameError] = useState(false)
  const [lastnameError, setLastnameError] = useState(false)
  const [phoneError, setPhoneError] = useState(false)
  const [addressError, setAddressError] = useState(false)
  const [phoneFormatError, setPhoneFormatError] = useState(false)
  const [updateError, setUpdateError] = useState(false)
  const [zipError, setZipError] = useState(false)
  const [zipFormatError, setZipFormatError] = useState(false)
  const [tycError, settycError] = useState(false)

  /* ----- Error flags ----- */

  const [disableButton, setdisableButton] = useState(false)

  const errorLabel = (
    <label className="f-input-label-error">*Campo requerido</label>
  )

  const handleSubmit = e => {
    e.preventDefault()

    if (!haveErrors()) {
      setModalActive(
        <OtpModal setCommondModal={setModalActive} nextFunct={nextToOTP} />,
      )
    }
  }

  const nextToOTP = inputValueOTPAux => {
    let addressDetail =
      process.env.LOCALE !== "es-PR"
        ? addressDetailValue
        : addressDetailValue + " ZIP: " + zipCodeValue

    let payload = {
      adult: userInfo.adult,
      cellPhone:
        phoneValue === "" ||
        phoneValue === " " ||
        phoneValue === null ||
        phoneValue === undefined
          ? null
          : process.env.COUNTRY_PHONE_PREFIX +
          (process.env.LOCALE === "es-PY"
            ? parseInt(phoneValue, 10).toString()
            : parseInt(phoneValue).toString()),
      codeDestination: userInfo.codeDestination,
      country: userInfo.country,
      location: {
        city: ciudadSelected,
        address: addressValue,
        addressDetail: addressDetail,
      },
      email: userInfo.email,
      lastName: lastnameValue,
      name: nameValue,
      profilePicture: userInfo.profilePicture,
      otp: inputValueOTPAux,
    }

    let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

    let config = {
      headers: {
        Authorization: tokenId,
      },
    }

    AuthService.updateAccount(payload, config)
      .then(res => {
        if (res.status === 200) {
          setdisableButton(false)
          // setInfoUser(res.data)
          localStorage.setItem("USER_INFO", JSON.stringify(res.data))

          let copyUpdateData = localStorage.getItem(
            "UPDATE_DATA_SAMPLE_PRODUCT",
          )
          copyUpdateData = copyUpdateData ? JSON.parse(copyUpdateData) : []
          copyUpdateData.push({
            email: res.data.email,
            activityId: ACTIVITY_ID_MUESTREO,
          })
          localStorage.setItem(
            "UPDATE_DATA_SAMPLE_PRODUCT",
            JSON.stringify(copyUpdateData),
          )

          DataPolicyService.updatePolicy(getPayloadCheck(), config)
            .then(res => {
              console.log("Habeas data update")
            })
          setActualStep(3)
        } else {
          setErrorMessage(res.userMessage)
          setUpdateError(true)
          setdisableButton(false)
        }
      })
      .catch(e => console.log(e))
  }

  const mistakeCellByCountry = num => {
    return (
      num.toString().length < parseInt(process.env.MIN_DIGITS) ||
      num.toString().length > parseInt(process.env.MAX_DIGITS)
    )
  }

  const haveErrors = () => {

    if (isAllChecksTrue()) {
      settycError(true)
    } else {
      settycError(false)
    }

    if (nameValue === "" || nameValue === " ") {
      setNameError(true)
    } else {
      setNameError(false)
    }

    if (lastnameValue === "" || lastnameValue === " ") {
      setLastnameError(true)
    } else {
      setLastnameError(false)
    }

    if (
      phoneValue !== "" &&
      phoneValue !== " " &&
      phoneValue !== null &&
      phoneValue !== undefined
    ) {
      if (mistakeCellByCountry(phoneValue)) {
        setPhoneFormatError(true)
        return true
      } else {
        setPhoneFormatError(false)
      }
    }

    if (phoneValue === "" || phoneValue === " " || phoneValue === null) {
      setPhoneError(true)
    } else {
      setPhoneError(false)
    }

    if (addressValue === " " || addressValue === "") {
      setAddressError(true)
    } else {
      setAddressError(false)
    }

    if (
      [null, undefined].includes(zipCodeValue) ||
      zipCodeValue.trim() === ""
    ) {
      setZipFormatError(true)
      return true
    } else {
      setZipFormatError(false)
    }

    if (zipCodeValue === "" || nameValue === " ") {
      setZipError(true)
    } else {
      setZipError(false)
    }

    return (
      isAllChecksTrue() ||
      nameValue === "" ||
      nameValue === " " ||
      lastnameValue === "" ||
      lastnameValue === " " ||
      phoneValue === "" ||
      phoneValue === " " ||
      phoneValue === null ||
      addressValue === "" ||
      addressValue === " " ||
      zipCodeValue === "" ||
      nameValue === " " ||
      zipCodeValue === null
    )
  }

  const cityLabel =
    process.env.LOCALE === "es-PR"
      ? "Municipio"
      : process.env.LOCALE === "es-PE"
        ? "Distrito"
        : "Ciudad"

  const singleLabel =
    process.env.LOCALE === "es-EC" ||
    process.env.LOCALE === "es-AR" ||
    process.env.LOCALE === "es-DO" ||
    process.env.LOCALE === "es-UY"
      ? "Provincia"
      : process.env.LOCALE === "es-CL"
        ? "Región"
        : "Departamento"

  const houseCopie =
    process.env.LOCALE === "es-PE"
      ? "Urbanización / N° Departamento / Referencia"
      : process.env.LOCALE === "es-DO"
        ? "Sector / edificio / apartamento"
        : "Barrio / edificio / apartamento"

  return (
    <div className="container">
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-left rounded-top-left-no-mov hidden-mov-large background-color-primary" />
      ) : null}
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-top-mov background-color-primary" />
      ) : null}
      <div
        className={
          "details rounded-top-no-mov activity-modal-style " +
          (["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO)
            ? "muestra-gratis-antibacterial container-step-background"
            : "muestreo-normal")
        }
      >
        <div
          className={
            "details-step-update-data " +
            (ACTIVITY_ID_MUESTREO == "48"
              ? "muestreo-special-container"
              : ACTIVITY_ID_MUESTREO == "91" || ACTIVITY_ID_MUESTREO == "92"
                ? "muestreo-special-100"
                : "muestreo-normal-container")
          }
        >
          <div className="description">
            <h1 className={`text-color-secondary`}>Actualiza tus datos</h1>
            <p>
              Y si eres una ganadora, puedas recibir tu premio en casa, sin
              problemas.
            </p>
          </div>

          <div className={`form-update-data`}>
            <form onSubmit={handleSubmit}>
              <div className={`form-group`}>
                <div className={`input-group`}>
                  <label
                    className={
                      !["48", "91", "92", "137", "138"].includes(
                        ACTIVITY_ID_MUESTREO,
                      )
                        ? `label-color-input`
                        : ""
                    }
                  >
                    Nombre:
                  </label>
                  <input
                    className="border-color-input"
                    type="text"
                    value={nameValue}
                    onChange={e =>
                      setNameValue(e.target.value.replace(/ {2}/g, " "))
                    }
                  />
                  {nameError && errorLabel}
                </div>
                <div className={`input-group`}>
                  <label
                    className={
                      !["48", "91", "92", "137", "138"].includes(
                        ACTIVITY_ID_MUESTREO,
                      )
                        ? `label-color-input`
                        : ""
                    }
                  >
                    Apellido:
                  </label>
                  <input
                    className="border-color-input"
                    type="text"
                    value={lastnameValue}
                    onChange={e =>
                      setLastnameValue(e.target.value.replace(/ {2}/g, " "))
                    }
                  />
                  {lastnameError && errorLabel}
                </div>
              </div>

              <div className={`form-group`}>
                {process.env.LOCALE !== "es-PR" && (
                  <div className={`input-group`}>
                    <label
                      className={
                        !["48", "91", "92", "137", "138"].includes(
                          ACTIVITY_ID_MUESTREO,
                        )
                          ? `label-color-input`
                          : ""
                      }
                    >
                      {singleLabel}:
                    </label>
                    <select
                      className="border-color-input"
                      value={departamentoSelected}
                      onChange={e => setDepartamentoSelected(e.target.value)}
                    >
                      {departamentos.map((departamento, index) => {
                        return (
                          <option value={departamento.codigo} key={index}>
                            {departamento.nombre}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                )}

                {process.env.LOCALE === "es-PR" ? (
                  <div className={`input-group`}>
                    <label
                      className={
                        !["48", "91", "92", "137", "138"].includes(
                          ACTIVITY_ID_MUESTREO,
                        )
                          ? `label-color-input`
                          : ""
                      }
                    >
                      {cityLabel}:
                    </label>
                    <select
                      className="border-color-input"
                      value={ciudadSelected}
                      onChange={e => setCiudadSelected(e.target.value)}
                    >
                      {ciudades.map((ciudad, index) => {
                        return (
                          <option value={ciudad.codigo} key={index}>
                            {ciudad.nombre}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                ) : (
                  departamentoSelected !== "" && (
                    <div className={`input-group`}>
                      <label
                        className={
                          !["48", "91", "92", "137", "138"].includes(
                            ACTIVITY_ID_MUESTREO,
                          )
                            ? `label-color-input`
                            : ""
                        }
                      >
                        {cityLabel}:
                      </label>
                      <select
                        className="border-color-input"
                        value={ciudadSelected}
                        onChange={e => setCiudadSelected(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {ciudades
                          .filter(
                            ciu =>
                              ciu.codigoDepartamento === departamentoSelected,
                          )
                          .map((ciudad, index) => {
                            return (
                              <option value={ciudad.codigo} key={index}>
                                {ciudad.nombre}
                              </option>
                            )
                          })}
                      </select>
                    </div>
                  )
                )}
              </div>

              <div className={`form-group`}>
                <div className={`input-group`}>
                  <label
                    className={
                      !["48", "91", "92", "137", "138"].includes(
                        ACTIVITY_ID_MUESTREO,
                      )
                        ? `label-color-input`
                        : ""
                    }
                  >
                    Dirección:
                  </label>
                  <input
                    className="border-color-input"
                    type="numeric"
                    value={addressValue}
                    maxLength="100"
                    onChange={e => {
                      setAddressValue(
                        e.target.value
                          .replace(
                            /[^a-zA-ZáéíóúÁÉÍÓÚ,.0-9#°;:()¿?¡!_\- ]/g,
                            "",
                          )
                          .replace(/ {2}/g, " ")
                          .slice(0, 100),
                      )
                    }}
                  />
                  {addressError && errorLabel}
                </div>

                <div className={`input-group`}>
                  <label
                    className={
                      !["48", "91", "92", "137", "138"].includes(
                        ACTIVITY_ID_MUESTREO,
                      )
                        ? `label-color-input`
                        : ""
                    }
                  >
                    Datos adicionales de tu ubicación:
                  </label>
                  <input
                    className="border-color-input"
                    placeholder={houseCopie}
                    maxLength="60"
                    type="numeric"
                    value={addressDetailValue}
                    onChange={e => {
                      setaddressDetailValue(
                        e.target.value
                          .replace(
                            /[^a-zA-ZáéíóúÁÉÍÓÚ,.0-9#°;:()¿?¡!_\- ]/g,
                            "",
                          )
                          .replace(/ {2}/g, " ")
                          .slice(0, 60),
                      )
                    }}
                  />
                </div>
              </div>

              <div className={`form-group`}>
                {process.env.LOCALE === "es-PR" && (
                  <div className={`input-group`}>
                    <label
                      className={
                        !["48", "91", "92", "137", "138"].includes(
                          ACTIVITY_ID_MUESTREO,
                        )
                          ? `label-color-input`
                          : ""
                      }
                    >
                      {" "}
                      ZIP Code:
                    </label>
                    <input
                      className="border-color-input"
                      type="text"
                      value={zipCodeValue}
                      onChange={e => setZipCodeValue(e.target.value)}
                    />
                    {zipError && errorLabel}
                    {zipFormatError && (
                      <label className="f-input-label-error">
                        *ZIP Code inválido
                      </label>
                    )}
                  </div>
                )}

                <div className={`input-group`}>
                  <label
                    className={
                      !["48", "91", "92", "137", "138"].includes(
                        ACTIVITY_ID_MUESTREO,
                      )
                        ? `label-color-input`
                        : ""
                    }
                  >
                    Celular:
                  </label>
                  <input
                    className="border-color-input"
                    type="numeric"
                    value={phoneValue}
                    onChange={e =>
                      setPhoneValue(
                        e.target.value
                          .replace(/\D/, "")
                          .slice(0, parseInt(process.env.MAX_DIGITS)),
                      )
                    }
                  />
                  {phoneError && errorLabel}
                  {phoneFormatError && (
                    <label className="f-input-label-error">
                      *Número inválido
                    </label>
                  )}
                </div>
              </div>
              {updateError && (
                <p
                  className={
                    !["48", "91", "92", "137", "138"].includes(
                      ACTIVITY_ID_MUESTREO,
                    )
                      ? `error-update red`
                      : "error-update"
                  }
                >
                  Tus datos no se pudieron actualizar.{" "}
                  {errorMessage && errorMessage}
                </p>
              )}

              <div className="habeas-data__win-product">
                <div className="f-step-question-checkBox-group">
                  {checksPolicy.map((item, index) => {
                    // si es distinto a mis puntos
                    if (item.idPrincipal !== "pbAccepted") {
                      return (
                        <div className="f-step-question-form-checkBox" key={item.idPrincipal}>
                          <input
                            onChange={e => {
                              handleChangeChecks(e, index)

                            }}
                            type="checkbox"
                            name="terms"
                            value="Bike"
                          />
                          <p className="f-step-question-form-checkBox-copy">
                            <a
                              className="f-step-question-form-link"
                              rel="noopener noreferrer"
                              target="_blank"
                              href={homeLink + item.redireccion}
                            >
                              {item.tituloPrincipal}
                            </a>
                          </p>
                          <span className="f-checkmark"></span>
                        </div>
                      )
                    }
                  })}

                  {tycError &&
                  <label className="f-label-error">
                    *Debes aceptar para continuar
                  </label>
                  }

                </div>
                <DataPolicy />
              </div>
              <div className={`button-submit`}>
                <Button
                  disabled={disableButton}
                  className={`button${
                    disableButton ? "-disabled" : ""
                  } background-color-primary-button`}
                  title="Actualizar"
                />
              </div>


            </form>
          </div>
        </div>
      </div>
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-right rounded-top-right-no-mov hidden-mov-large background-color-primary" />
      ) : null}
    </div>
  )
}

export default StepUpdateData
